import { createFileRoute } from '@tanstack/react-router'
import { DoctorAvailabilityPage } from '@/features/users/availability/overview'

export const Route = createFileRoute('/users_/$userId/availability')({
  component: RouteComponent,
})

function RouteComponent() {
  const { userId } = Route.useParams()
  return <DoctorAvailabilityPage userId={userId} />
}
